import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, Inject, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { UserApiActions } from '../../../@store/user/user.actions';
import {
  selectUnarchivedUserError,
  selectUnarchivedUserSuccess,
} from '../../../@store/user/user.selectors';
import { SafeAny } from '../../../types/safe-any';

@Component({
  selector: 'ciwc-unarchived-user-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './unarchived-user-dialog.component.html',
  styleUrls: ['./unarchived-user-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnarchivedUserDialogComponent {
  private readonly store = inject(Store);
  readonly unarchivedUserSuccess = this.store.selectSignal(selectUnarchivedUserSuccess);
  readonly unarchivedUserError = this.store.selectSignal(selectUnarchivedUserError);

  isArchiving = signal(false);

  constructor(
    public dialogRef: MatDialogRef<UnarchivedUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SafeAny,
  ) {
    effect(() => {
      if (this.isArchiving()) {
        if (this.unarchivedUserSuccess()) {
          this.dialogRef.close();
        }

        if (this.unarchivedUserError()) {
          this.isArchiving.set(false);
        }
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.isArchiving.set(true);

    this.store.dispatch(UserApiActions.unarchiveUser({ userId: this.data.user.id }));
  }
}
